module.exports = __webpack_public_path__ + "img/fisher-note-edit.402bed90.svg";